import {BIRTHDAY_CATEGORIES, HOLIDAY_CATEGORIES} from '~/create/components/GiftRegistries/utils';
import {stringifyParams} from '~/common/utils';

export const getGiftlistType = () => {
  const eventType = window.evite_event.event_type;
  let giftlistType;

  if (BIRTHDAY_CATEGORIES.includes(eventType)) {
    giftlistType = 'birthday';
  } else if (HOLIDAY_CATEGORIES.includes(eventType)) {
    giftlistType = 'holiday';
  } else {
    giftlistType = 'custom';
  }

  return giftlistType;
};

export function getCompiledAmazonGiftlistUrl() {
  const event = window.evite_event;

  const params = stringifyParams({
    eventOwnerName: event.host_name,
    month: event.start_datetime.slice(4, 6),
    day: event.start_datetime.slice(6, 8),
    year: event.start_datetime.slice(0, 4),
    state: event.state || '',
    registryName: event.title,
    showFullDetails: 1,
    tag: 'amazongiftlists-20',
    asc_campaign: escape('giftlist=treatment'),
  });

  const giftlistUrl = `https://www.amazon.com/registries/${getGiftlistType()}/create?${params}`;

  return giftlistUrl;
}
